import React, { Component } from 'react'
import axios, { AxiosInstance } from 'axios'
import { withTranslation } from 'react-i18next'
import { RatatoskRequest, valueByFormikPath, valueNotEmpty } from '../../common'
import { Container, Dropdown as PDropdown, Grid, Header, Icon, Message, Modal, Segment, Tab } from 'semantic-ui-react'
//import Loader from '../Loader'
import Form from '../form/Form'
import CNCDictForm from './CNCDictForm'
import Input from '../form/Input'
import * as CNC from '../../CNC_common'
import Button from '../form/Button'
import Checkbox from '../form/Checkbox'
import { FieldArray } from 'formik'
import { setFieldValue } from '../form/FormikHelpers'
import CNCDictListSublemmas from './CNCDictListSublemmas'
import CNCDictBatchChange from './CNCDictBatchChange'
import i18n from 'i18next'
import { CNCDictProps } from './CNCDict'

interface CNCDictSublemmaState {
    sublemma: string,
    formData: {groups: object, add: object},
    selectedGroup: string,
    loading: boolean,
    submitting: boolean,
    errorMsg: string,
    batchDialogOpen: string|null,
    newParadigmGroup: string,
    newPatternPath: string,
    patternList: any[],
    newPattern: any
}

export const domain2obj = (domain: string) => {
    return ({
        written: domain.includes('written'),
        spoken: domain.includes('spoken'),
    })
}

export const tag2mclass = (tag: string) => {
    if (tag.startsWith('N'))
        return 'N'+tag.substring(2,3)
    else if (tag.startsWith('A'))
        return 'A'+tag.substring(1,2)
    else if (tag.startsWith('C'))
        return 'C'+tag.substring(1,2)
    else if (tag.startsWith('V'))
        return 'V'+tag.substring(12,13)
    else if (tag.startsWith('D'))
        return 'D'+tag.substring(1,2)
    else if (tag.startsWith('J'))
        return 'J'+tag.substring(1,2)
    else if (tag.startsWith('S'))
        return 'S'+tag.substring(1,2)
    else if (tag.startsWith('B'))
        return 'B'+tag.substring(1,2)
    else if (tag.startsWith('Z'))
        return 'Z'+tag.substring(1,2)
    else if (tag.startsWith('X'))
        return 'X'+tag.substring(1,2)
    return tag.substring(0,1)
}

export const makeGroupLink = (sublemma: string, lemma: string, tag: string) => {
    return `/comp/cncdict/sublemma/${sublemma}_${lemma}_${tag2mclass(tag)}`
}

export const collectUpdates = (cur, initial) => {
    let changes: object[] = []
    if (cur.domain.written !== initial.domain.written || cur.domain.spoken !== initial.domain.spoken) {
        let domain: string[] = []
        if (cur.domain.written) domain.push('written')
        if (cur.domain.spoken) domain.push('spoken')
        changes.push({type: ':form:cncdict:domain', value: domain})
    }
    if (cur.lemma!==initial.lemma)
        changes.push({type: ':form:attr:cnc:w:lemma', value: cur.lemma, target: 'form/1'})
    if (changes.length)
        return {update_features: changes}
    return null
}

export const addForms = async (http, forms: any[]) => {
    let formList: any[] = []
    for (let form of forms) {
        if (!form.ignored) {
            formList.push({
                'type': ':cncdict:form',
                'name': form.word,
                'slots': [
                    {
                        'pos': 1,
                        'name': 'form',
                        'type': ':term:fixed',
                        'fillers': [
                            {
                                'name': '1',
                                'type': ':token:cnc:form',
                                'feats': [
                                    {'type': ':form:attr:cnc:w:word', 'value': form.word},
                                    {'type': ':form:attr:cnc:w:lemma', 'value': form.lemma},
                                    {'type': ':form:attr:cnc:w:sublemma', 'value': form.sublemma},
                                    {'type': ':form:attr:cnc:w:tag', 'value': form.tag},
                                ]
                            }
                        ],
                        'feats': []
                    }
                ],
                'feats': [
                    {'type': ':form:cncdict:domain', 'value': form.domain}
                ]
            })
        } else {
            formList.push({
                'type': ':cncdict:form',
                'name': form.word,
                'slots': [
                    {
                        'pos': 1,
                        'name': 'form',
                        'type': ':term:fixed',
                        'fillers': [
                            {
                                'name': '1',
                                'type': ':token:cnc:word',
                                'feats': [
                                    {'type': ':form:attr:cnc:w:word', 'value': form.word}
                                ]
                            }
                        ],
                        'feats': []
                    }
                ],
                'feats': [
                    {'type': ':form:cncdict:ignored'}
                ]
            })
        }
    }
    const url = 'cunits/_new'
    try {
        const response = await http.put(url, formList)
        return response.data.data
    } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
            return(err.response.data.message||err.response.data)
        } else {
            console.log(err)
            return(i18n.t('Uknown error'))
        }
    }
}

export const delForms = async (http: AxiosInstance, units: any[]) => {
    const pathList = units.map(u => u.path)
    const url = 'cunits/_batch'
    try {
        const response = await http.delete(url, {data: pathList})
        return response.data.data
    } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
            return(err.response.data.message||err.response.data)
        } else {
            console.log(err)
            return(i18n.t('Uknown error'))
        }
    }
}

export const delForm = async (http, unit) => {
    const url = 'cunits/'+unit.path
    try {
        await http.delete(url)
        return null
    } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
            return(err.response.data.message||err.response.data)
        } else {
            console.log(err)
            return(i18n.t('Uknown error'))
        }
    }
}

export const updateForm = async (http, unit, updates) => {
    const url = 'cunits/'+unit.path
    try {
        await http.post(url, updates)
        return null
    } catch (err) {
        if (axios.isAxiosError(err) && err.response) {
            return(err.response.data.message||err.response.data)
        } else {
            console.log(err)
            return(i18n.t('Uknown error'))
        }
    }
}

export const response2groups = (data: any[]) => {
    const groups = data.reduce((acc, u: any) => {
        const lemma = u._slots[0]._fillers[0][':form:attr:cnc:w:lemma']
        const tag = u._slots[0]._fillers[0][':form:attr:cnc:w:tag']
        const mclass = tag2mclass(tag)
        const gclass = lemma+'_'+mclass
        if (!acc[gclass]) acc[gclass] = []
        acc[gclass].push({
            active: true,
            id: u._id,
            path: u._path,
            form: u._slots[0]._fillers[0][':form:attr:cnc:w:word'],
            tag: tag,
            lemma: lemma,
            sublemma: u._slots[0]._fillers[0][':form:attr:cnc:w:sublemma'],
            domain: domain2obj(u[':form:cncdict:domain'])
        })
        return acc
    }, {})
    return groups
}

export const updateUnit = async (http: AxiosInstance, unit: any, initialUnit: any, errors: string[]) => {
    // return false for complately deleted units, true for updated
    // errors are pushed into the error string array
    if (unit.id) {
        if (!unit.active) {
            // this should now be obsolete and useless
            const res = await delForm(http, unit)
            if (res) errors.push(res)
            else return(false)
        } else {
            const updates = collectUpdates(unit, initialUnit)
            if (updates) {
                const res = await updateForm(http, unit, updates)
                if (res) errors.push(res)
            }
        }
    } else {
        let domain: string[] = []
        if (unit.domain.written) domain.push('written')
        if (unit.domain.spoken) domain.push('spoken')
        const add = {sublemma: unit.sublemma, lemma: unit.lemma, word: unit.form, tag: unit.tag, domain: domain}
        const res = await addForms(http, [add])
        if (typeof res === 'string') errors.push(res)
        else if (!res.length) errors.push(i18n.t("Empty response."))
        else if (res[0]._error) errors.push(res[0]._error)
        else {
            unit.id = res._id
            unit.path = res._path
        }
    }
    return(true)
}

export const filterPatterns = (patternList: any[], sublemma: string, patternBase: string) => {
    if (!patternList) return []
    //const tagPatterns = patternList.filter(p => p[':form:cncdict:base_tag'].startsWith(tagBase||''))
    const tagPatterns = patternList.filter(p => p['_name'].startsWith(patternBase||''))
    const endingPatterns = tagPatterns.filter(p => sublemma.endsWith(p[':form:cncdict:base_ending']))
    const constrPatterns = endingPatterns.filter(p => sublemma.match(`^.*(${p[':form:cncdict:base_constraints']})${p[':form:cncdict:base_ending']}$`))
    const sortedPatterns = constrPatterns.sort((a,b) => 
        a['_name'].startsWith(patternBase+'_') && !b['_name'].startsWith(patternBase+'_') ? -1 :
        !a['_name'].startsWith(patternBase+'_') && b['_name'].startsWith(patternBase+'_') ? 1 :
        a[':form:cncdict:base_ending'].length > b[':form:cncdict:base_ending'].length ? -1 :
        a[':form:cncdict:base_ending'].length < b[':form:cncdict:base_ending'].length ? 1 :
        a[':form:cncdict:base_constraints'].length > b[':form:cncdict:base_constraints'].length ? -1 :
        a[':form:cncdict:base_constraints'].length < b[':form:cncdict:base_constraints'].length ? 1 : 0
    )
    return(sortedPatterns)
}

export const createParadigm = (sublemma: string, lemma: string, pattern: any, includeTags = [], excludeTags = []) => {
    let baseEnding = ''
    let paradigm = {}
    // deal both with view and full unit
    const feats = pattern['feats'] ? pattern['feats'] :
        Object.keys(pattern).filter(i => !i.startsWith('_')).map(type => ({type: type, value: pattern[type]}))

    for (let f of feats) {
        if (f['type']===':form:cncdict:base_ending') baseEnding = f['value']
        else if (f['type'].startsWith(':form:cncdict:ending:')) {
            const [rtag, sspec] = f['type'].substring(21).split(':')
            const tag = rtag.replace(';',':')
            const ending = f['value']
            if (includeTags.length) {
                const match_pos = includeTags.filter(t => RegExp(t).test(tag))
                if (!match_pos.length) continue
            }
            const match_neg = excludeTags.filter(t => RegExp(t).test(tag))
            if (match_neg.length) continue
            if (!paradigm[ending]) paradigm[ending] = []
            paradigm[ending].push(tag)
        }
    }
    const stem = sublemma.substring(0,sublemma.length-baseEnding.length)
    let forms: any[] = []
    for (let ending in paradigm) {
        let [prefix, end] = ending.split('|')
        if (end===undefined) {
            end = prefix
            prefix = ''
        }
        for (let tag of paradigm[ending]) {
            forms.push({
                active: true,
                id: null,
                path: null,
                form: prefix+stem+(end||''),
                tag: tag,
                lemma: lemma,
                sublemma: sublemma,
                domain: {written: true, spoken: true}
            })
        }
    }
    return forms
}

class CNCDictSublemma extends Component<CNCDictProps, CNCDictSublemmaState> {

    state = {
        formData: {groups: {}, add: {}},
        loading: false,
        submitting: false,
        errorMsg: '',
        selectedGroup: '',
        sublemma: '',
        batchDialogOpen: null,
        newParadigmGroup: '',
        newPatternPath: '',
        newPattern: {},
        patternList: [] as any[]
    }

    componentDidMount() {
        const [sublemma, ...gclassArr] = this.props.match.params['sublemma'].split('_')
        let lemmaSpec = gclassArr.join('_')
        this.setState({sublemma: sublemma, selectedGroup: lemmaSpec})
    }

    componentDidUpdate(prevProps: Readonly<CNCDictProps>, prevState: Readonly<CNCDictSublemmaState>, snapshot?: any): void {
        const { patternList, newParadigmGroup, loading } = this.state
        if (loading) return
        const [sublemma, ...gclassArr] = this.props.match.params['sublemma'].split('_')
        const lemmaSpec = gclassArr.join('_')
        // new paradigm
        if (this.props.match.params['dir']==='new') {
            // we have new paradigm to be created
            if (!patternList.length) {
                this.loadPatternList()
            }
            const spec = gclassArr.length > 1 ? lemmaSpec : 
                gclassArr.length ? `${sublemma}_${lemmaSpec}` : sublemma
            if (newParadigmGroup!==spec || sublemma!==this.state.sublemma) {
                let groups = {}
                groups[spec] = []
                this.setState({sublemma: sublemma, newParadigmGroup: spec, selectedGroup: spec, formData: {groups: groups, add: {}}})
            }
            return
        }
        // sublemma or lemmaSpec changed
        if (sublemma!==this.state.sublemma || lemmaSpec!==this.state.selectedGroup) {
            this.loadDictData(sublemma)
            this.setState({selectedGroup: lemmaSpec})
            return
        }
        // sublemma changed: load new data from dictionary
        if (this.state.sublemma!==prevState.sublemma) {
            this.loadDictData(this.state.sublemma)
            return
        }
    }

    buildNewParadigm(newPattern: any, lemma: string) {
        const { sublemma } = this.state
        const forms = createParadigm(sublemma, lemma, newPattern)
        if (forms.length) {
            const tag = forms[0].tag
            forms.sort(CNC.sortFunc[tag.substring(0,1)])
        }
        return(forms)
    }

    loadPatternList() {
        const { t } = this.props
        let request: RatatoskRequest = {
            query: {
                'type': ':cncdict:pattern'
            },
            page: { from: 0, size: 10000 },
            feats: [
                ":form:cncdict:base_ending",
                ":form:cncdict:base_tag",
                ":form:cncdict:base_constraints"
            ]
        }
        this.setState({loading: true})
        const url = 'cunits/_view'
        this.props.http.post(url, request)
            .then(response => {
                this.setState({patternList: response.data.data, errorMsg: '', loading: false})
            }).catch(err => {
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false})
                } else {
                    this.setState({errorMsg: t('Unknown error'), loading: false})
                }
            })
    }

    loadDictData(sublemma) {
        let request: RatatoskRequest = {
            query: {
                'type': ':cncdict:form',
                'feats': [
                    {type: ':form:attr:cnc:w:sublemma', value: sublemma}
                ]
            },
            page: { from: 0, size: 1000 },
            feats: [':form:attr:cnc:w', ':form:cncdict:domain']
        }
        this.setState({loading: true})
        const url = 'cunits/_view'
        this.props.http.post(url, request)
            .then(response => {
                const groups = response2groups(response.data.data)
                let nextState = {sublemma: sublemma, errorMsg: '', loading: false}
                /* const { selectedGroup } = this.state
                let selected = selectedGroup
                // sublemma does not exist yet
                if (Object.keys(groups).length===0) {
                    selected = sublemma
                    nextState['selectedGroup'] = selected
                }*/
                // group does not exist yet
                /*if (selected && !(Object.keys(groups).filter(x => x===selected || x.startsWith(selected+'_')).length)) {
                    groups[selected] = []
                    nextState['newParadigmGroup'] = selected
                } else {
                    nextState['newParadigmGroup'] = ''
                }*/
                nextState['formData'] = {groups: groups, add: {}}
                this.setState(nextState)
            }).catch(err => {
                this.setState({loading: false})
                if (err.response) {
                    this.setState({errorMsg: err.response.data.message||err.response.data, loading: false})
                }
            })
    }

    async update(group, values, initialValues, formik) {
        const { http } = this.props
        const { newParadigmGroup,  sublemma } = this.state
        this.setState({loading: true})
        let errors: string[] = []
        let newValues = {groups: {}, add: {}}
        let curSublemma = this.state.sublemma
        let curGroup = group
        let to_delete: any[] = []
        for (let gname in values.groups) {
            const g = values.groups[gname]
            for (let uk in g) {
                let u = g[uk]
                let gclass = gname
                if (gname===group) {
                    const initialUnit = initialValues.groups[group][uk]
                    if (u.id && !u.active) {
                        to_delete.push(u)
                        continue
                    }
                    const res = await updateUnit(http, u, initialUnit, errors)
                    if (!res) continue
                    const mclass = tag2mclass(u.tag)
                    gclass = u.lemma+'_'+mclass
                    curSublemma = u.sublemma
                    curGroup = gclass
                }
                if (!newValues.groups[gclass])
                    newValues.groups[gclass] = []
                newValues.groups[gclass].push(u)
            }
        }
        if (to_delete.length) {
            const res = await delForms(http, to_delete)
            if (typeof res === 'string') errors.push(res)
            else if (!res.length) errors.push(i18n.t("Empty response."))
            else {
                for (let r of res) {
                    if (r._error) {
                        errors.push(r._error)
                        const u = to_delete.filter(u => u.path===r._path)[0]
                        const mclass = tag2mclass(u.tag)
                        const gclass = u.lemma+'_'+mclass
                        if (!newValues.groups[gclass])
                            newValues.groups[gclass] = []
                        newValues.groups[gclass].push(u)
                    }
                }
            }
        }
        const newForm = values.add[group]
        if (newForm) {
            const sublemma = newForm.sublemma
            const lemma = newForm.lemma
            const word = newForm.word
            for (let tv of newForm.tags) {
                let domain: string[] = []
                if (tv.written) domain.push('written')
                if (tv.spoken) domain.push('spoken')
                const u = {lemma: lemma, sublemma: sublemma, word: word, tag: tv.tag, domain: domain}
                let res = await addForms(http, [u])
                if (typeof res === 'string') errors.push(res)
                else if (!res.length) errors.push(i18n.t("Empty response."))
                else if (res[0]._error) errors.push(res[0]._error)
                else {
                    const mclass = tag2mclass(u.tag)
                    const gclass = u.lemma+'_'+mclass
                    if (!newValues.groups[gclass])
                        newValues.groups[gclass] = []
                    newValues.groups[gclass].push({
                        active: true,
                        id: res._id,
                        path: res._path,
                        form: word,
                        tag: tv.tag,
                        lemma: lemma,
                        sublemma: sublemma,
                        domain: {written: tv.written, spoken: tv.spoken}
                    })
                }
            }
        }
        if (errors.length) {
            // keep form state if something failed
            this.setState({errorMsg: errors.join("\n"), loading: false})
        } else {
            if (group!==newParadigmGroup) {
                if (curSublemma==sublemma)
                    this.setState({formData: newValues, loading: false})
                else
                    window.location.href = window.location.href.replace(/\/sublemma\/[^\/]*$/, `/sublemma/${curSublemma}_${curGroup}`)
            } else {
                window.location.href = window.location.href.replace(/\/new\/[^\/]*$/, `/${curSublemma}_${curGroup}`)
            }
        }
    }

    render() {
        const { meta, t, i18n, history, location } = this.props
        const { sublemma, formData, loading, selectedGroup, batchDialogOpen, newPatternPath, newParadigmGroup, patternList } = this.state
        
        if (!(meta['cats']['cunit']) || !(meta['uis']['edit'])) return null

        //if (loading) return (<Container><Segment><Loader/></Segment></Container>) // breaks formik updates!

        if (!Object.keys(formData.groups).length) return null

        //const [lemma, mclass] = selected_group.split('_')

        /*const mclassOptions = Object.keys(groups).reduce((arr: any, k: string) => {
            const [l, cl] = k.split('_')
            if (lemma===l && !arr.includes(cl))
                arr.push({key: cl, value: cl, text: cl})
            return arr
        }, [])*/

        let selectedTab = 0

        Object.keys(formData.groups).forEach((g, gi) => {
            const tag = g.split('_')[1]
            if (tag) {formData.groups[g].sort(CNC.sortFunc[tag.substring(0,1)])}
            if (g===selectedGroup || g.startsWith(selectedGroup+'_')) selectedTab = gi
        })

        const [lemma, patternBase] = newParadigmGroup.split('_')
        const myPatterns = filterPatterns(patternList, sublemma, patternBase)
        const patternOptions = myPatterns.map(p => ({key: p._path, value: p._path, text: p._name}))

        const tagMaskMatch = (value, mask) => {
            if (value===undefined) return // this happens when an item is completely removed - ignore it!
            const pattern = new RegExp(`^${mask}.*$`)
            if (!pattern.test(value)) return t("Value does not match expected class")+` '${mask}'`
        }

        const newTag = {tag: '', written: true, spoken: true}

        const addNewTag = (formik, group, tag) => {
            const myNewTag = {tag: tag, written: true, spoken: true}
            let tags = valueByFormikPath(`add.${group}.tags`, formik.values)
            if (!tags) return
            if (tags.length && tags[tags.length-1].tag==='') tags[tags.length-1].tag = tag
            else tags = tags.concat(myNewTag)
            setFieldValue(formik, `add.${group}.tags`, tags, true)
        }

        const setAllAdd = (formik, group, domain, value) => {
            let tags = valueByFormikPath(`add.${group}.tags`, formik.values)
            for (let i in tags) setFieldValue(formik, `add.${group}.tags.${i}.${domain}`, value, true)
        }

        const setDomain = (formik, group, form, domain, value) => {
            let units = JSON.parse(JSON.stringify(formik.values.groups[group]))
            for (let i in units) {
                const u = units[i]
                if (!form || u.form===form) u.domain[domain] = value
            }
            setFieldValue(formik, `groups.${group}`, units, true)
        }

        const setActive = (formik, group, form, value) => {
            let units = JSON.parse(JSON.stringify(formik.values.groups[group]))
            for (let i in units) {
                const u = units[i]
                if (!form || u.form===form) u.active = value
            }
            setFieldValue(formik, `groups.${group}`, units, true)
        }

        const setActiveByTag = (formik, group, tag, value) => {
            let units = JSON.parse(JSON.stringify(formik.values.groups[group]))
            const re = RegExp(tag)
            for (let i in units) {
                const u = units[i]
                if (u.tag.match(re)) u.active = value
            }
            setFieldValue(formik, `groups.${group}`, units, true)
        }

        const setLemma = (formik, group, form, value) => {
            let units = JSON.parse(JSON.stringify(formik.values.groups[group]))
            for (let i in units) {
                const u = units[i]
                if (!form || u.form===form) u.lemma = value
            }
            setFieldValue(formik, `groups.${group}`, units, true)
        }

        const tabChange = (e, d) => {
            const newSpec = Object.keys(formData.groups)[d.activeIndex]
            history.push(`/comp/cncdict/sublemma/${sublemma}_${newSpec}`)
            e.stopPropagation()
        }

        const setNewParadigm = (formik, patternPath) => {
            const { t } = this.props
            const { newParadigmGroup } = this.state
            this.setState({loading: true})
            const url = 'cunits/'+patternPath
            this.props.http.get(url)
                .then(response => {
                    // generate new paradigm
                    const [lemma, ...other] = newParadigmGroup.split('_')
                    const newPattern = response.data.data[0]
                    this.setState({errorMsg: '', loading: false, newPatternPath: patternPath})
                    const newForms = this.buildNewParadigm(newPattern, lemma)
                    setFieldValue(formik, `groups.${newParadigmGroup}`, newForms, true)
                }).catch(err => {
                    if (err.response) {
                        this.setState({errorMsg: t(err.response.data.message), loading: false})
                    } else {
                        console.log(err)
                        this.setState({loading: false})
                    }
                })
        }

        const searchReplace = (formik, group, search, replace) => {
            const re = RegExp(search)
            const units = formik.values.groups[group]
            let newUnits: any[] = []
            for (let i in units) {
                const oldF = formik.values.groups[group][i]
                const newF = {
                    active: true,
                    id: null,
                    path: null,
                    form: oldF.form.replace(re, replace),
                    tag: oldF.tag,
                    lemma: oldF.lemma.replace(re, replace),
                    sublemma: oldF.sublemma.replace(re, replace),
                    domain: {written: oldF.domain.written, spoken: oldF.domain.spoken}
                }
                newUnits.push(newF)
            }
            setFieldValue(formik, `groups.${group}`, newUnits, true)
            setFieldValue(formik, `add.${group}`, undefined, true)
        }

        const panes = Object.keys(formData.groups).map(grpname => {
            const group_specs = grpname.split('_')
            const lemma = group_specs[0]
            let tagMask = group_specs[1]

            return (
            {
                menuItem: grpname, 
                pane: (
                    <Tab.Pane>
                    <Form initialValues={formData} className="editform"
                        onSubmit={(values: object, formikApi) => this.update(grpname, values, formData, formikApi)}>
                        {(formik) => {
                            if (!formik.values.groups[grpname]) return (null) // WTF?
                            const newClone = formik.values.groups[grpname].length>0 && sublemma!==formik.values.groups[grpname][0].sublemma
                            const curSublemma = newClone ? formik.values.groups[grpname][0].sublemma : sublemma
                            const curLemma = newClone ? formik.values.groups[grpname][0].lemma : lemma
                            const newForm = {sublemma: curSublemma, lemma: curLemma, word: '', tags: [{tag: '', written: true, spoken: true}]}
                            const batchMessage = t("Set for all forms of sublemma '{{sublemma}}', lemma '{{lemma}}' ({{count}})",
                                {sublemma: curSublemma, lemma: grpname, count: formData.groups[grpname].length})
                            const unitsByForm = formik.values.groups[grpname].reduce((acc, u, ui) => {
                                if (!acc[u.form]) acc[u.form] = []
                                u.index = ui
                                acc[u.form].push(u)
                                return acc
                            }, {})
                            // new paradigm may not have tagMask set
                            if (typeof tagMask === 'undefined') {
                                tagMask = formik.values.groups[grpname].length ? tag2mclass(formik.values.groups[grpname][0].tag) : ''
                            }
                            const pos = tagMask ? tagMask.substring(0,1) : ''
                            // in case of new paradigm, generate it using the first available option by default
                            if (this.state.newParadigmGroup===grpname && !newPatternPath && patternOptions.length && !loading) {
                                setNewParadigm(formik, patternOptions[0].value)
                            }
                            
                            return (
                                <>
                                <Modal size="tiny" open={batchDialogOpen===grpname} closeIcon={true} onClose={() => this.setState({batchDialogOpen: null})} centered={false}>
                                    <Modal.Content>
                                        <Grid>
                                            <Grid.Row>
                                                <Grid.Column width={16}>
                                                    <Message info header={t('Batch change')} content={batchMessage}/>
                                                </Grid.Column>
                                            </Grid.Row>
                                            <CNCDictBatchChange {...this.props} formik={formik} group={grpname} form={null} pos={pos}
                                                setDomain={setDomain} setLemma={setLemma} setActive={setActive}
                                                searchReplace={searchReplace} setActiveByTag={setActiveByTag}
                                                close={() => this.setState({batchDialogOpen: null})}/>
                                        </Grid>
                                    </Modal.Content>
                                </Modal>
                                <Segment>
                                <Grid>
                                { newClone ?
                                    <Grid.Row>
                                        <Grid.Column width={16}>
                                            <Message info header={t('Replaced paradigm')} 
                                                content={t("The original paradigm has been replaced with a new clone. New sublemma '{{sublemma}}'.", {sublemma: formik.values.groups[grpname][0].sublemma})}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                : null}
                                    <Grid.Row>
                                        <Grid.Column width={14}>
                                            <Header as='h1'>
                                                <Header.Content>
                                                    {formik.values.groups[grpname][0]?.sublemma || sublemma}
                                                    <Header.Subheader style={{display:'inline-block',marginLeft:'.5em'}}>{t('sublemma')}</Header.Subheader>
                                                </Header.Content>
                                            </Header>
                                            <CNCDictListSublemmas key={curLemma+'_'+curSublemma} {...this.props} lemma={curLemma} sublemma={curSublemma}/>
                                        </Grid.Column>
                                        <Grid.Column width={2} textAlign='right'>
                                            <Button.Submit disabled={!(formik.dirty && formik.isValid)} icon size="mini"title={t('Save changes')}><Icon name="save"/></Button.Submit>
                                            <Button type="button" color="blue" icon="edit" size="mini" onClick={() => this.setState({batchDialogOpen: grpname})} title={t('Batch change')}/>
                                        </Grid.Column>
                                    </Grid.Row>
                                { this.state.newParadigmGroup === grpname ? 
                                    <Grid.Row verticalAlign='middle'>
                                        <Grid.Column width={2}>
                                            <div className="label">{t('Pattern')}</div>
                                        </Grid.Column>
                                        <Grid.Column width={8}>
                                        <PDropdown fluid search selection value={this.state.newPatternPath} options={patternOptions} 
                                            onChange={(e, {value}) => setNewParadigm(formik, value as string)}/>
                                        </Grid.Column>
                                        <Grid.Column width={6}>
                                        </Grid.Column>
                                    </Grid.Row>
                                : null}
                                </Grid>
                                <Segment>
                                { formik.values.add[grpname] ?
                                    <Grid>
                                        <Grid.Row className='condensed'>
                                            <Grid.Column width={4}>
                                                <strong>{t('Add form')}</strong>
                                            </Grid.Column>
                                            <Grid.Column width={12} textAlign='right'>
                                                <Button icon="delete" type="button" size='mini' color='red' onClick={() => setFieldValue(formik, `add.${grpname}`, undefined, true)}/>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row className='condensed'>
                                            <Grid.Column width={4}>
                                                <Input name={`add.${grpname}.word`} validate={valueNotEmpty} noHighlighting/>
                                            </Grid.Column>
                                            <Grid.Column width={8}>
                                                <FieldArray name={`add.${grpname}.tags`}
                                                    render={(subformik) => (
                                                    <Grid>
                                                    {formik.values.add[grpname].tags.map((tv, ti) => {
                                                        return (
                                                            <Grid.Row className='condensed'>
                                                                <Grid.Column width={10}>
                                                                    <Input name={`add.${grpname}.tags.${ti}.tag`} validate={(v) => tagMaskMatch(v, pos)} noHighlighting/>
                                                                </Grid.Column>
                                                                <Grid.Column width={4}>
                                                                    <Checkbox name={`add.${grpname}.tags.${ti}.written`} label={t('written')} fieldProps={{className: "compactfield"}} noHighlighting/>
                                                                    <Checkbox name={`add.${grpname}.tags.${ti}.spoken`} label={t('spoken')} fieldProps={{className: "compactfield"}} noHighlighting/>
                                                                </Grid.Column>
                                                                <Grid.Column width={2}>
                                                                    { formik.values.add[grpname].tags.length>1 ? 
                                                                        <Button type="button" color="red" icon="delete" size="mini" title={t('delete')} 
                                                                            onClick={(e,d) => {
                                                                                subformik.remove(ti)
                                                                            }}/> 
                                                                        :
                                                                        <Button type="button" color="red" icon="delete" size="mini" title={t('delete')} 
                                                                            onClick={(e,d) => {
                                                                                setFieldValue(formik, `add.${grpname}.tags.${ti}.tag`, '', true)
                                                                            }}/>
                                                                        }
                                                                </Grid.Column>
                                                            </Grid.Row>
                                                        )
                                                    })}
                                                    <Grid.Row className='condensed'>
                                                        <Grid.Column width={16}>
                                                            <Button icon="plus" type="button" size='mini' color='blue' onClick={(e,d) => subformik.push(newTag)}/>
                                                        </Grid.Column>
                                                    </Grid.Row>
                                                    </Grid>)}/>
                                            </Grid.Column>
                                            <Grid.Column width={4} textAlign='left'>
                                                <Grid>
                                                <Grid.Row className='condensed' verticalAlign='middle'>
                                                    <Grid.Column width={2}>
                                                    <Button icon="check" type="button" size='mini' color='blue' onClick={() => setAllAdd(formik, grpname, 'written', true)}/>
                                                    </Grid.Column>
                                                    <Grid.Column width={2}>
                                                    <Button icon="delete" type="button" size='mini' color='red' onClick={() => setAllAdd(formik, grpname, 'written', false)}/>
                                                    </Grid.Column>
                                                    <Grid.Column width={12}>
                                                    {t('written')}
                                                    </Grid.Column>
                                                </Grid.Row>
                                                <Grid.Row className='condensed' verticalAlign='middle'>
                                                    <Grid.Column width={2}>
                                                    <Button icon="check" type="button" size='mini' color='blue' onClick={() => setAllAdd(formik, grpname, 'spoken', true)}/>
                                                    </Grid.Column>
                                                    <Grid.Column width={2}>
                                                    <Button icon="delete" type="button" size='mini' color='red' onClick={() => setAllAdd(formik, grpname, 'spoken', false)}/>
                                                    </Grid.Column>
                                                    <Grid.Column width={12}>
                                                    {t('spoken')}
                                                    </Grid.Column>
                                                </Grid.Row>
                                                </Grid>
                                            </Grid.Column>
                                        </Grid.Row>
                                        <Grid.Row>
                                            <Grid.Column width={16}>
                                            <Button.Submit disabled={!(formik.dirty && formik.isValid)} icon><Icon name="save"/> {t('Save changes')}</Button.Submit>
                                            </Grid.Column>
                                        </Grid.Row>
                                    </Grid>
                                :
                                    <>
                                    <Button icon="plus" type="button" size='mini' color='blue' 
                                        onClick={() => setFieldValue(formik, `add.${grpname}`, newForm, true)}/> <strong>{t('Add form')}</strong>
                                    </>
                                }
                                </Segment>
                                { Object.keys(unitsByForm).map((form: string) => {
                                    const units = unitsByForm[form]
                                    return(
                                        <CNCDictForm {...this.props} prefix={`groups`} group={grpname} formik={formik}
                                            setDomain={setDomain} setActive={setActive} setLemma={setLemma} batchDialogOpen={batchDialogOpen}
                                            setBatchDialogOpen={(v) => this.setState({batchDialogOpen: v})}
                                            form={form} units={units} setNewTag={(v) => addNewTag(formik, grpname, v)}/>
                                    )
                                  })
                                }
                                <Button.Submit disabled={!(formik.dirty && formik.isValid)} icon><Icon name="save"/> {t('Save changes')}</Button.Submit>
                                </Segment>
                                </>
                            )
                        }}
                    </Form>
                    </Tab.Pane>
                )
            })
        })

        return(
            <>
            <>{this.state.errorMsg ?
              (
                <Container>
                    <Message error icon='exclamation triangle' header={t('Error')} content={this.state.errorMsg}/>
                </Container>
              ) : null}
            </>
            <Container>
                <Tab panes={panes} renderActiveOnly={false} activeIndex={selectedTab} onTabChange={tabChange}/>
            </Container>
            </>
        )
    }

}

export default withTranslation()(CNCDictSublemma)